import { render, staticRenderFns } from "./OneStageDetailsPage.vue?vue&type=template&id=3821c7e6&scoped=true"
import script from "./OneStageDetailsPage.vue?vue&type=script&lang=js"
export * from "./OneStageDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821c7e6",
  null
  
)

export default component.exports